import * as reduxUtil from 'redux/utils/reducers';
import * as consts from 'redux/constants';

const stateKeys = {
  cardTokenizationPage: 'cardTokenizationPage',
  tokenizeCard: 'tokenizeCard'
};

const initialState = {
  cardTokenizationPage: reduxUtil.initializeObject(),
  tokenizeCard: reduxUtil.initializeObject(),
  cardPayment: {
    token: '',
    status: ''
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case consts.GET_CARD_TOKENIZATION_PAGE_START: {
      return reduxUtil.updateStartAction({
        state,
        key: stateKeys.cardTokenizationPage
      });
    }
    case consts.GET_CARD_TOKENIZATION_PAGE_SUCCESS: {
      const { data } = action?.payload || {};
      return reduxUtil.updateSuccessAction({
        state,
        key: stateKeys.cardTokenizationPage,
        data
      });
    }
    case consts.GET_CARD_TOKENIZATION_PAGE_FAIL: {
      const { error } = action?.payload || {};
      return reduxUtil.updateFailAction({
        state,
        key: stateKeys.cardTokenizationPage,
        error
      });
    }
    case consts.UPDATE_CARD_TOKENIZATION_PAGE:
      return {
        ...state,
        cardTokenizationPage: {
          ...state.cardTokenizationPage,
          data: {
            ...state.cardTokenizationPage.data,
            ...action.payload
          }
        }
      };
    case consts.SET_CARD_PAYMENT:
      return {
        ...state,
        cardPayment: {
          token: action.payload.token,
          status: action.payload.status,
          next_action: action.payload.next_action,
          card_payment_token: action.payload.card_payment_token
        }
      };
    case consts.TOKENIZE_CARD_START: {
      return reduxUtil.updateStartAction({
        state,
        key: stateKeys.tokenizeCard
      });
    }
    case consts.TOKENIZE_CARD_SUCCESS: {
      const { data } = action?.payload || {};
      return reduxUtil.updateSuccessAction({
        state,
        key: stateKeys.tokenizeCard,
        data
      });
    }
    case consts.TOKENIZE_CARD_FAIL: {
      const { error } = action?.payload || {};
      return reduxUtil.updateFailAction({
        state,
        key: stateKeys.tokenizeCard,
        error
      });
    }
    default:
      return state;
  }
};

export default reducer;
